module.exports = __webpack_public_path__ + "img/sport-types.d8efe172.png";